@if (f != null && f.visible) {
  <div [ngClass]="(fullHeight ? 'height100p ' : '') + (f.labelLeft ? 'flex-row' : 'flex-col') + ' gap-1 ' + (_FrontendFieldType.hasLabel(f.type) && f.hasLabel ? 'mb-3 mt-3' : 'mb-2') + (f.indent == 0 ? '' : ' ml-' + f.indent)">
    @if (hasVisibleLabel()) {
      @if (multipleFields == null) {
        <ng-container *ngTemplateOutlet="labelTemplate; context: { field: f }"></ng-container>
      }
      @else {
      <div [ngClass]="isInlineGroup() ? 'sm-form-field-inline-group gap-2' : 'flex-row gap-1'">
        @for (f2 of multipleFields; track f2; let  i = $index) {
          @if (f2.visible) {
            <div [ngClass]="isInlineGroup() ? 'sm-form-field-inline-group-item' : 'flex-item-fill'" [style.width]="isInlineGroup() ? null : f2.guiWidthInGroup + '%'">
              @if (f2.hasLabelAdvanced() && !f2.isGuiOneLine() && (f2.guiGroupOwnLabel || f2.guiGroupOwnLabel == null && i == 0)) {
                <ng-container *ngTemplateOutlet="labelTemplate; context: { field: f2 }"></ng-container>
              }
            </div>
          }
        }
      </div>
    }
  }
  @if (multipleFields == null) {
    <app-sm-form-field-wrapper [class.height100p]="fullHeight" [field]="field" [child]="child2">
      <ng-template #child2>
        <app-sm-form-field-internal class="width100p" [attr.data-frontend-field-id]="field.id" [ngClass]="field.controlStyleClass" #componentInternal [form]="form" [field]="field" [fullHeight]="fullHeight" (onClick)="onClick">
        </app-sm-form-field-internal>
      </ng-template>
    </app-sm-form-field-wrapper>
  }
  @else {
  @if (fixedPos) {
    @for (f2 of multipleFields; track f2) {
      @if (f2.visible) {
        <app-sm-form-field-internal [attr.data-frontend-field-id]="f2.id" [ngClass]="f2.controlStyleClass" #componentInternal [form]="form" [field]="f2" [fullHeight]="fullHeight"s (onClick)="onClick">
        </app-sm-form-field-internal>
      }
    }
  }
  @else {
  <div [ngClass]="isInlineGroup() ? 'sm-form-field-inline-group gap-2' : 'flex-row gap-1'">
    @for (f2 of multipleFields; track f2) {
      @if (f2.visible) {
        <div [ngClass]="isInlineGroup() ? 'sm-form-field-inline-group-item' : 'flex-item-fill'" [class.sm-form-field-group-one-line]="!isInlineGroup() && f2.isGuiOneLine()" [class.sm-form-field-group-checkbox]="!isInlineGroup() && f2.type == _FrontendFieldType.bool" [style.width]="isInlineGroup() ? null : f2.guiWidthInGroup + '%'">
          <app-sm-form-field-wrapper [field]="f2" [child]="child">
            <ng-template #child>
              <app-sm-form-field-internal class="width100p" [attr.data-frontend-field-id]="f2.id" [ngClass]="f2.controlStyleClass" #componentInternal [form]="form" [field]="f2" [fullHeight]="fullHeight" (onClick)="onClick">
              </app-sm-form-field-internal>
            </ng-template>
          </app-sm-form-field-wrapper>
        </div>
      }
      @if (f2.hasLabelAdvanced() && !f2.isGuiOneLine() && f2.labelLeft && !_Utils.isNoe(f2.captionAfter)) {
        <ng-container *ngTemplateOutlet="labelTemplate; context: { field: f2, after: true }"></ng-container>
      }
    }
  </div>
}
}

</div>
}
<ng-template #labelTemplate let-field="field" let-after="after">
  <span
    [class]="(after ? 'ml-3' : 'mr-3') + (field.labelLeft ? ' mt-2' : '') + (field.labelStyleClass != null ? ' ' + field.labelStyleClass : '')"
    [style.text-align]="field.labelRightAligned ? 'right' : 'left'"
    [style.position]="fixedPos ? 'absolute' : undefined"
    [style.left.px]="fixedPos ? field.fixedLabelBounds.x : undefined"
    [style.top.px]="fixedPos ? field.fixedLabelBounds.y : undefined"
    [style.width.px]="fixedPos ? (field.fixedLabelBounds.width + (field.mandatory && mandatoryFieldsRedAsterisk ? 10 : 0)) : undefined"
    [style.height.px]="fixedPos ? field.fixedLabelBounds.height : undefined"
    [style.overflow]="'hidden'"
    >
    <label [pTooltip]="field.tooltip" [tooltipStyleClass]="field.tooltipStyleClasses" [class.req-asterisk] = "field.mandatory && mandatoryFieldsRedAsterisk" [class.req-underline] = "field.mandatory && !mandatoryFieldsRedAsterisk">
      {{after ? field.captionAfter : field.caption}}
    </label>
    @for (hint of field.guiHints; track hint) {
      <span>
        <p-avatar class="hint-icon p-avatar-sm" [icon]="hint.icon" [style]="hint.iconOnly ? {'color': hint.color, 'background-color': 'transparent'} : {'color': '#ffffff', 'background-color': hint.color}" shape="circle" [pTooltip]="hint.toolTip" (onClick)="clickGuiHint(hint)"></p-avatar>
        @if (field.isGuiOneLine() && hint.text != null && hint.text != '') {
          <span class="ml-2" [style]="{'color': hint.color}">{{hint.text}}</span>
        }
      </span>
    }
  </span>
</ng-template>
